<template>
  <div>
    <div class="container">
      <div v-if="isAdmin" class="row">
        <div class="col text-right">
          <i v-on:click="showPostModal" class="far fa-plus-square"></i>
        </div>
      </div>
      <div class="card-columns">
        <div v-for="entry in entries" v-on:click="toPost(entry.postId)" v-bind:key="entry.key">
          <entry-card v-bind:caption="entry.caption"
            v-bind:title="entry.title"
            v-bind:image="entry.image"
            v-bind:userId="entry.userId"
            v-bind:postId="entry.postId"></entry-card>
        </div>
      </div>
    </div>
    <post-modal ref="postModal"></post-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AWS from 'aws-sdk/global'
import AWSConnector from 'http-aws-es'
import EntryCard from './EntryCard.vue'
import elasticsearch from 'elasticsearch'
import router from '../../router/index.js'
import PostModal from './PostModal.vue'

export default {
  metaInfo: {
    title: 'Insights',
    meta: [
      { vmid: 'description', content: 'Helpful blog posts to help you with your home needs.' }
    ]
  },
  created () {
    this.elasticSearch()
    if (this.getIdProvider) this.checkIfAdmin()
  },
  data () {
    return {
      searchFrom: 0,
      searchStringQP: '*',
      entries: [],
      postId: null,
      isAdmin: false
    }
  },
  components: {
    EntryCard,
    PostModal
  },
  computed: {
    ...mapGetters([
      'getIdProvider',
      'getAccessKeyId',
      'getSecretAccessKey',
      'getSessionToken'
    ])
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    hidePostModal () {
      this.$refs.postModal.$refs.postModal.hide()
    },
    showPostModal () {
      this.$refs.postModal.$refs.postModal.show()
    },
    toPost (postId) {
      var dest = '/insights/' + postId
      router.push(dest)
    },
    async checkIfAdmin () {
      var client = this.$store.getters.getBlogApigClientFactory
      var params = {}
      var pathTemplate = '/blog/admin'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.isAdmin = result.data.is_admin
      } catch (error) {
        console.log(error)
      }
    },
    async elasticSearch () {
      try {
        if (!this.getSecretAccessKey) await this.unauthenticatedLogin()
        AWS.config.update({
          credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
          region: window.CONFIG.Region
        })
        var client = new elasticsearch.Client({
          connectionClass: AWSConnector,
          host: window.CONFIG.SearchDomain,
          apiVersion: '6.4'
        })
        const results = await client.search({
          index: 'blog',
          type: '_doc',
          from: this.searchFrom,
          body: {
            size: 25,
            query: {
              query_string: {
                query: this.searchStringQP + '~' // Tilde allows handling of spelling errors
              }
            }
          }
        })
        this.entries = results.hits.hits.map((entry) => {
          return {
            postId: entry._source.post_id,
            title: entry._source.title,
            image: entry._source.title_image,
            caption: entry._source.description,
            userId: entry._source.user_id
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.container {
  margin-top: 2rem;
}

.far {
  font-size: 1.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/insights/Insights.vue